import wsPoliciesTemplate from './wsPolicies.html';

/*****************************************************************************
 * @ngdoc   component
 * @mdule   csm.ui.webStore
 * @name    csm.ui.webStore.component:wsPolicies
 *
 * @param {object}  store       Store properties.
 * @param {Array}   processors  Array of Processor objects
 * @param {Boolean} showCf      Indication to show the Convenience Fee Policy
 *                              management section.
 *
 * @description
 * This component displays the policies tab of the webStore admin page. Default
 * or custom policies can be created and saved to be displayed in the webStore.
 *****************************************************************************/
export const wsPoliciesComponent = {
  bindings: { store: '<', processors: '<', showCf: '<' },
  template: wsPoliciesTemplate,
  controller: WsPoliciesController
};

/*****************************************************************************
 * Controller: WsPoliciesController
 *
 * Controller for the organization info and payment processors.
 *****************************************************************************/
/* @ngInject */ function WsPoliciesController($scope, Tools, SERVER) {
  /***************************************************************************
   * Constants
   ***************************************************************************/
  /*---------------*/
  /* Default Texts */
  /*---------------*/
  var DEFAULT_PAYPAL_CF_POLICY =
    'The following convenience fee will be applied to each purchase and added to your total: ${1} per transaction plus {2}% of the total.';
  var DEFAULT_CF_POLICY =
    'The convenience fee applied to transactions is determined by the service agreement between {0} and your webstore provider. Please contact the store ' +
    'administrator to determine these specific fees. You will also see these fees indicated on your purchase receipt upon checkout.';
  var DEFAULT_PRIVACY_POLICY =
    'All information collected is for the purpose of completing an order. Any information we collect is used for the purpose of providing you with a more ' +
    'satisfying and personalized shopping and browsing experience. Payments are processed by {0}, a secure and trusted internet site for online purchases.';

  /*-------------------------------------------------*/
  /* Processor Convenience Fee Default Configuration */
  /*-------------------------------------------------*/
  var convenienceFeeConfigs = [
    {
      type: SERVER.BooksDBConstants.PT_PACE,
      label: 'Pace',
      cfPolicy: DEFAULT_CF_POLICY
    },
    {
      type: SERVER.BooksDBConstants.PT_PAY_PAL,
      label: 'PayPal',
      cfPolicy: DEFAULT_PAYPAL_CF_POLICY
    },
    {
      type: SERVER.BooksDBConstants.PT_OPEN_EDGE,
      label: 'OpenEdge',
      cfPolicy: DEFAULT_CF_POLICY
    },
    {
      type: SERVER.BooksDBConstants.PT_KPS,
      label: 'KPS',
      cfPolicy: DEFAULT_CF_POLICY
    }
  ];

  /***************************************************************************
   * Properties
   ***************************************************************************/
  /** Self Reference. */ var mThis = this;
  /** Current Convenience Fee Config. */ var mCFConfig = null;

  /***************************************************************************
   * getCurrentProc */
  /**
   * Sets mCFConfig based off the set store processor type.
   ***************************************************************************/
  function getCurrentProc() {
    /*--------------------*/
    /* Get the processor. */
    /*--------------------*/
    var currentProc =
      (mThis.processors || []).find(function (p) {
        return p.id == mThis.store.config.processorID;
      }) || {};

    /*---------------------------------*/
    /* Set corresponding configuration */
    /*---------------------------------*/
    mCFConfig = currentProc
      ? convenienceFeeConfigs.find(function (cf) {
          return cf.type == currentProc.type;
        })
      : null;
  }

  /***************************************************************************
   * defaultConvenience */
  /**
   * Default convenience policy. Fires on button click to load the default policy
   ***************************************************************************/
  mThis.defaultConvenience = function () {
    var fixedFee = Tools.roundToPrecision(
      mThis.store.config.convenienceFeeFixed,
      2
    );
    var percentFee = Tools.roundToPrecision(
      mThis.store.config.convenienceFeePercent * 100,
      2
    );

    var cf = mCFConfig || { label: '', cfPolicy: '' };

    mThis.store.config.convenienceFeePolicy = cf.cfPolicy.format(
      cf.label,
      fixedFee,
      percentFee
    );
  };

  /***************************************************************************
   * defaultPrivacy */
  /**
   * Default privacy policy. Fires on button click to load the default policy
   ***************************************************************************/
  mThis.defaultPrivacy = function () {
    mThis.store.config.privacyPolicy = mCFConfig
      ? DEFAULT_PRIVACY_POLICY.format(mCFConfig.label)
      : '';
  };

  /*----------------------------------------*/
  /* Watch for changes to the processorID   */
  /* so the default policies can be updated */
  /*----------------------------------------*/
  $scope.$watch('$ctrl.store.config.processorID', getCurrentProc);
}
